import { ColumnsType } from 'antd/lib/table';
import { InvoiceDto } from 'common/dto/generated/InvoiceDto';
import { InvoiceFilteredColumns } from './table/InvoiceColumns';

export const InvoiceCommunicationColumns: ColumnsType<InvoiceDto> = [
  InvoiceFilteredColumns.issuedNumber,
  InvoiceFilteredColumns.issuedDate,
  InvoiceFilteredColumns.expiresAt,
  InvoiceFilteredColumns.state,
  InvoiceFilteredColumns.supplierName,
  InvoiceFilteredColumns.totalAmount
];
